import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import "./fullNewsPost.css";
import { useSelector } from "react-redux";
import { formatDate } from "../../../config/dateFormat";
import Socials from "../../Socials";
import SlidingCarousel from "../Carousel/SlidingCarousel";

const FullNewsPost = () => {
  const { newbloglist } = useSelector((state) => state.newsblog);
  const [data, setData] = useState({});
  const { newstitle } = useParams();
  const [newsPosts, setNewsPosts] = useState([]);

  useEffect(() => {
    setNewsPosts(newbloglist.filter((items) => items.category === "news"));
  }, [newbloglist]);

  useEffect(() => {
    const filteredData = newbloglist?.find(
      (newsitems) => newsitems.title === newstitle
    );
    setData(filteredData);
  }, [newstitle, newbloglist]);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  if (!data) {
    return <div>Post not found</div>;
  }

  return (
    <div className="flex flex-col gap-2 justify-start items-center">
      <div className="w-full flex flex-col justify-center px-4 py-2">
        <div className="w-full flex justify-center gap-5 min-h-[70vh]  flex-wrap items-center h-fit">
          <div className="flex flex-col gap-4 items-start w-[30%] min-w-[320px] h-fit flex-grow max-w-[80%]">
            <span className="text-[30px] font-bold">{data.title}</span>
            <span className="text-[18px] font-light">{data.caption}</span>
          </div>

          <div className="max-w-[800px] min-w-[320px] h-[100%] w-[55%] rounded-3xl overflow-hidden">
            {data.imageurl && (
              <img
                src={data.imageurl}
                alt={data.title}
                className="w-full h-fit"
              />
            )}
          </div>
        </div>

        <div className="flex gap-2 items-center">
          <span className="text-[14px] font-semibold">Published on: </span>
          <span className="text-[14px] text-[#8888]">
            {formatDate(data.modified)}
          </span>
        </div>
      </div>

      <hr />

      <div className="w-full flex gap-1 px-4 ql-editor">
        <div className="max-w-[300px] w-[40%]"></div>
        <div
          className="flex-1 min-w-[350px] pr-8 py-2 flex flex-wrap"
          dangerouslySetInnerHTML={{ __html: data.text }}
        />
      </div>

      <Socials />

      <div className="w-[90%] bg-[#f5f5f5] flex justify-center items-center mb-9">
        <SlidingCarousel
          newsPosts={newsPosts}
          header="More News"
          buttontxt=""
        />
      </div>
    </div>
  );
};

export default FullNewsPost;
